export default __webpack_public_path__ + "static/media/T680MANC7.e0940141.pdf";